import React from 'react';
import PropTypes from 'prop-types';

import Alert from 'react-bootstrap/Alert';
import Button from '@components/smartAdminUI/Button';

const RowLockOwnerMessage = ({
  isAutoSave = false,
  onRemoveLock = () => null,
}) => (
  <div className="row">
    <div className="col-lg-12">
      <Alert variant="warning">
        <h3>
          <i className="far fa-lock mr-2" />
          This entity is currently locked.
        </h3>
        {isAutoSave && (
          <p>Although you currently hold a lock for this entity, you must first decide what to do with your unsaved changes below before proceeding.</p>
        )}
        {!isAutoSave && (
          <>
            <p>You currently hold a lock for this entity. You may either release the lock or perform any other task you wish by clicking one of the buttons in the Listing Details panel header below.</p>
            <Button name="btnReleaseLock" variant="primary" onClick={onRemoveLock}>
              <i className="fas fa-lock-open mr-2" aria-hidden="true" />
              Release lock
            </Button>
          </>
        )}
      </Alert>
    </div>
  </div>
);

RowLockOwnerMessage.propTypes = {
  isAutoSave: PropTypes.bool,
  onRemoveLock: PropTypes.func,
};

export default RowLockOwnerMessage;
